import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getDefaultTooltipFormatterWithTotal, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerContentTypeByInfluencerChart = ({ data, influencerLabelMap, pending }) => {
  const { categories, series } = useMemo(() => {
    const categories = mapIdsToLabels(data?.influencerIds, influencerLabelMap);

    return {
      categories,
      series: [
        { name: 'Photos', data: data?.photoEarnings || [] },
        { name: 'Videos', data: data?.videoEarnings || [] },
        { name: 'Bundles', data: data?.bundleEarnings || [] },
      ],
    };
  }, [data, influencerLabelMap]);
  const tooltipFormatter = useMemo(() => getDefaultTooltipFormatterWithTotal('currency'), []);

  return (
    <OrganizationAnalyticsBarChart
      title="Content Type Earnings By Creator"
      subtitle="Breakdown of creator earnings by media type."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to compare content type earnings."
      stacked
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationInfluencerContentTypeByInfluencerChart;
